import Damsel from './Damsel';

const defaultBackground = '#D7E5F0'

type LevelOptions = {
  backgroundColor: string
}

export default class Level {

  public damsels: Damsel[] = []
  public background = defaultBackground

  constructor(options?: Partial<LevelOptions>) {
    const { backgroundColor } = options || {}
    if(backgroundColor) {
      this.background = backgroundColor
    }
  }

  public addDamsel(damsel: Damsel) {
    this.damsels.push(damsel)
  }
  public removeDamsel(index: number) {
    this.damsels.splice(index, 1)
  }
  public getDamsel(index: number) {
    if(this.damsels[index]) {
      return this.damsels[index]
    } else {
      throw new Error('No damsel at index ' + index)
    }
  }

  public findDamselById(id: number) {
    return this.damsels.find(d => d.id === id) || null
  }



  


}